import { Injectable } from '@angular/core';
import { v4 as uuid } from 'uuid';

@Injectable({
	providedIn: 'root'
})
export class IdService {
	private ids: Set<string>;

	constructor() {
		this.ids = new Set<string>();
	}

	/**
	 * Generates unique ID and keeps track of it so it can't be used again until removed
	 * @returns string
	 */
	generate(): string {
		let id: string;

		do {
			id = 'rbc-' + uuid().substring(0, 8);
		} while (this.ids.has(id));

		this.ids.add(id);

		return id;
	}

	/**
	 * Removes unique ID from record, enabling it to be used again
	 * @param id
	 * @returns void
	 */
	remove(id: string): void {
		this.ids.delete(id);
	}
}
